import React from "react";
import {
  FaDribbble,
  FaFacebookF,
  FaPinterest,
  FaTwitter,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";

const Footer = () => {
  return (
    <LargeContainer bg='url("/footer.png")' style={{ marginTop: "auto" }}>
      <ContentContainer>
        <Container style={{ flexGrow: "1.5" }}>
          <img src="/logo.png" alt="logo" />
          Lorem ipsum dolor sit amet, consec adipisl elit, sed do eiusmod tempor
          incidio ut labore et dolore magna.
          <Heading>
            <IconContainer>
              <FaFacebookF />
              <FaTwitter />
              <FaPinterest />
              <FaDribbble />
            </IconContainer>
          </Heading>
        </Container>

        <Container style={{ flexGrow: "1" }}>
          <Heading>My Account</Heading>
          <SubHeading to="/login">Sign In</SubHeading>
          <SubHeading to="/cart">View Cart</SubHeading>
          <SubHeading to="/wishlist">My Wishlist</SubHeading>
          <SubHeading to="/dashboard/orders">Track My Order</SubHeading>
        </Container>

        <Container style={{ flexGrow: "1.5" }}>
          <Heading>
            Got Questions? Call Us
            <a href="tel:123456789">123 456 789</a>
          </Heading>
          <SubHeading to="/">
            221B, Baker Street,
            <br /> London
            <br />
            UK
          </SubHeading>
          <img src="/payment.png" alt="payment" />
        </Container>
      </ContentContainer>
    </LargeContainer>
  );
};
const ContentContainer = styled(MainContainer)`
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em;
  margin: 4rem 0rem;
  max-width: 22%;
  img {
    align-self: flex-start;
    justify-self: flex-start;
    padding: 1em 0;
    object-fit: none;
  }
`;
const Heading = styled.div`
  font-size: 1.2em;
  margin-bottom: 2rem;
  a {
    text-decoration: none;
    color: black;
    margin: 0.5em 0 0 0;
    display: block;
    font-size: 1.4em;
    transition: color 0.3s;
    :hover {
      color: #83aa4c;
    }
  }
`;

const SubHeading = styled(NavLink)`
  text-decoration: none;
  color: black;
  margin: 0.5rem 0;
  cursor: pointer;
  transition: color 0.3s;
  :hover {
    color: #83aa4c;
  }
`;
const IconContainer = styled.div`
  display: flex;
  margin: 1rem 0;

  & > * {
    font-size: 1.8em;
    margin-right: 0.5rem;
    border: 1px solid grey;
    padding: 0.5rem;
    cursor: pointer;

    transition: background-color 0.5s, color 0.5s, border 0.5s;
    :hover {
      background-color: #83aa4c;
      color: #fff;
      border: none;
    }
  }
`;

export default Footer;
